import React from 'react';
import { useNotification } from '../../context/NotificationContext';

const NotificationItem = ({ notification, onRemove }) => {
  const getNotificationConfig = (type) => {
    const configs = {
      error: {
        bgClass: 'bg-danger',
        icon: 'fas fa-times-circle',
        progressClass: 'bg-danger',
        bgColor: 'rgba(220, 53, 69, 0.1)',
      },
      success: {
        bgClass: 'bg-success',
        icon: 'fas fa-check-circle',
        progressClass: 'bg-success',
        bgColor: 'rgba(25, 135, 84, 0.1)',
      },
      warning: {
        bgClass: 'bg-warning',
        icon: 'fas fa-exclamation-triangle',
        progressClass: 'bg-warning',
        bgColor: 'rgba(255, 193, 7, 0.1)',
      },
      info: {
        bgClass: 'bg-info',
        icon: 'fas fa-info-circle',
        progressClass: 'bg-info',
        bgColor: 'rgba(13, 202, 240, 0.1)',
      },
    };
    return configs[type] || configs.error;
  };

  const config = getNotificationConfig(notification.type);

  return (
    <div 
      className={`notification-item toast show align-items-center border-0 mb-2 shadow-lg`}
      style={{
        background: config.bgColor,
        minWidth: '300px',
        maxWidth: '400px',
        animation: 'slideInRight 0.3s ease-out',
      }}
      role="alert"
    >
      <div className="d-flex w-100">
        <div className="toast-body d-flex align-items-start p-3">
          <div className="me-3 mt-1">
            <i className={`${config.icon} fs-5`}></i>
          </div>
          <div className="flex-grow-1">
            <div className="fw-bold mb-1">{notification.title}</div>
            <div className="small opacity-90">{notification.message}</div>
          </div>
        </div>
        <button
          type="button"
          className="btn-close btn-close-white me-2 m-auto"
          onClick={() => onRemove(notification.id)}
          aria-label="Close"
        ></button>
      </div>
      
      {/* Progress bar for auto-dismiss */}
      {notification.duration > 0 && (
        <div 
          className="progress-bar-container position-absolute bottom-0 start-0 w-100"
          style={{ height: '3px' }}
        >
          <div 
            className={`h-100 ${config.progressClass}`}
            style={{
              animation: `shrink ${notification.duration}ms linear`,
              opacity: 0.8,
            }}
          ></div>
        </div>
      )}
    </div>
  );
};

const NotificationContainer = () => {
  const { notifications, removeNotification } = useNotification();

  if (notifications.length === 0) return null;

  return (
    <div 
      className="notification-container position-fixed top-0 end-0 p-3"
      style={{ 
        zIndex: 1060,
        marginTop: '80px', // Account for header height
      }}
    >
      {notifications.map(notification => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onRemove={removeNotification}
        />
      ))}
    </div>
  );
};

export default NotificationContainer;